import {
  finishUserSignup as _finishUserSignup,
  FinishUserSignupPayload,
} from '@griply/services';
import { Locales } from '@griply/types';
import { httpsCallable } from 'firebase/functions';
import { QueryParamOptions } from 'shared/lib/react-router-dom';
import { getLoggableError, getRollbar } from 'shared/services/error-tracking';
import { UtmParameters } from 'shared/types/utm-parameters';
import { getCookie } from 'shared/utils/get-cookie';

import { getFunctions } from './helpers';

export type Options = {
  uid?: string | null;
  name?: string;
  locale?: Locales;
  hasNotifications?: boolean;
  queryParameters?: Partial<Record<UtmParameters | QueryParamOptions, string>>;
};

const getSource = (): string => {
  if (window.electron?.isMac) {
    return 'mac_app';
  }
  if (window.electron?.isWindows) {
    return 'win_app';
  }
  return 'web_app';
};

export const finishUserSignup = async ({
  uid,
  name,
  locale,
  hasNotifications,
  queryParameters,
}: Options) => {
  try {
    const payload: FinishUserSignupPayload = {
      name,
      locale,
      hasNotifications,
      queryParameters: (queryParameters ?? {}) as Record<string, string>,
      source: getSource(),
      _fprom_tid: getCookie('_fprom_tid'),
    };
    await _finishUserSignup({
      functions: getFunctions(),
      httpsCallable,
      payload,
    });
  } catch (error) {
    getRollbar().error('error trying to finish user signup', {
      uid,
      ...getLoggableError(error),
    });
  }
};
